export default __webpack_public_path__ + "static/media/pic2.d99a9de7.jpg";